<style scoped lang="css">
section {
  display: block;
}
section.main-section {
  height: 100%;
}
.wrap-container {
  flex-wrap: nowrap;
  overflow-x: auto;
  display: flex;
}

.card-image {
  flex: 0 0 auto;
  max-height: 140px;
  max-width: 140px;
}

.form-control {
  color: #212529;
}
</style>

<template>
  <div class="main-wrapper">
    <section class="section main-section bg-gradient-default min-vh-100 pt-3">
      <main class="container card shadow shadow-lg--hover mb-3">
        <b-overlay
          :show="isOverlayShown"
          variant="white"
          @shown="onOverlayShow"
          @hidden="onOverlayHide"
        >
          <Header :title="entry ? entry.name : 'Loading...'" />
          <div class="row" v-if="template">
            <div class="col-12">
              <span>
                Checklist creada el {{ template.createdOn | timestamp }},
                modificada el
                {{ template.lastUpdatedAt | timestamp }}
              </span>
            </div>
            <div class="col-8">
              <small>ID: {{ template.id }}</small>
            </div>
            <div class="col-4">
              <b-badge variant="primary" class="float-right"
                >Revision: {{ template.revision }}</b-badge
              >
            </div>
          </div>
          <b-row class="mt-3">
            <div class="col-12" v-if="entry && entryCreatedOn && entryId">
              <span>
                Entrada creada {{ entryCreatedOn | timestamp }}, modificada el
                {{ entry.lastUpdatedAt | timestamp }}
              </span>
            </div>
            <b-col cols="12">
              <small>ID: {{ entryId }}</small>
            </b-col>
            <b-col cols="12" v-if="checkpointTimestamp">
              <small>Autoguardado: {{ checkpointTimestamp | timestamp }}</small>
            </b-col>
          </b-row>
          <div class="row mt-3">
            <b-col cols="12">
              <p class="mb-0">
                Selecciona tú localidad
              </p>
              <small
                >el valor inicial es basado en tú ubicación, cambia la selección
                si no es correcta</small
              >
              <b-select
                v-model="entry.locality"
                :options="localities"
                value-field="locality"
                text-field="locality"
              >
              </b-select>
            </b-col>
            <b-col cols="12" class="mt-3">
              <p class="mb-0">
                Selecciona las im&aacute;genes relacionadas a la entrada
              </p>
            </b-col>
            <div class="col-12">
              <b-form-file
                v-model="files"
                variant="success"
                accept="image/*"
                multiple
              >
                <template
                  slot="file-name"
                  slot-scope="{ names }"
                  style="overflow: scroll;"
                >
                  <b-badge pill variant="dark">{{
                    names[0] | maxLength
                  }}</b-badge>
                  <b-badge
                    v-if="names.length > 1"
                    pill
                    variant="dark"
                    class="ml-1"
                  >
                    + {{ names.length - 1 }} More files
                  </b-badge>
                </template>
              </b-form-file>
            </div>
            <div class="col-12">
              <b-container fluid class="my-1">
                <b-row>
                  <b-col class="wrap-container">
                    <b-img
                      class="card-image p-1"
                      v-for="(img, key) in previewImages"
                      :key="key"
                      :src="img"
                    >
                    </b-img>
                  </b-col>
                </b-row>
              </b-container>
            </div>
            <div class="col-12">
              <b-form-textarea
                v-model="entry.notes"
                class="shadow-sm"
                max-rows="6"
                placeholder="Notas de la revision en general..."
                debounce="500"
              ></b-form-textarea>
            </div>
            <b-col cols="12" class="mt-1" v-show="filledCount > 0">
              <b-progress :max="totalQuestions" height="2rem">
                <b-progress-bar
                  :value="filledCount"
                  variant="success"
                  class="text-center"
                >
                  <span
                    >Completado
                    <strong>{{ filledCount }} de {{ totalQuestions }}</strong>
                  </span>
                </b-progress-bar>
              </b-progress>
            </b-col>
          </div>
          <b-card no-body>
            <b-tabs
              class="flex-column flex-md-row"
              card
              v-show="!userHasToAgreeToStart"
            >
              <b-tab
                v-for="(questions, category, indx) in categorizedQuestions"
                :key="category"
                class="pt-2"
                no-body
                lazy
                :title="category"
              >
                <template v-slot:title>
                  {{ indx + 1 }}. {{ category }}
                  <b-icon-check2-all v-if="isCategoryCompleted(category)" />
                  <b-icon-exclamation-circle scale="0.8" v-else />
                </template>
                <b-list-group>
                  <b-list-group-item
                    v-for="(question, key) in questions"
                    :key="key"
                    class="flex-column align-items-start"
                  >
                    <div class="row">
                      <b-col cols="2">
                        <p>{{ question.number }}.</p>
                      </b-col>
                      <b-col cols="8">
                        <p class="text-left">{{ question.name }}</p>
                      </b-col>
                      <b-col cols="2">
                        <b-form-checkbox
                          v-model="question.checked"
                          size="lg"
                        ></b-form-checkbox>
                      </b-col>
                    </div>
                    <div
                      class="row"
                      v-show="
                        question.description && question.description.length > 0
                      "
                    >
                      <div class="col-12 mb-3 mx-3">
                        <small>{{ question.description }}</small>
                      </div>
                    </div>
                    <b-row
                      align-h="end"
                      v-if="question.type && question.type === 'SELECTABLE'"
                      class="my-1"
                    >
                      <b-col cols="10">
                        <b-form-select v-model="question.selectedChoice">
                          <template v-slot:first>
                            <b-form-select-option
                              disabled
                              :value="null"
                              :text="
                                question.notes || 'Please select an option'
                              "
                            ></b-form-select-option>
                          </template>
                          <b-form-select-option
                            v-for="choice in question.choices"
                            :key="choice.value"
                            :value="choice"
                          >
                            {{ choice.name }}
                          </b-form-select-option>
                        </b-form-select>
                      </b-col>
                    </b-row>
                    <b-row align-h="end">
                      <b-col cols="10">
                        <b-form-textarea
                          class="shadow-sm"
                          v-model="question.notes"
                          max-rows="8"
                          rows="1"
                          placeholder="Notas"
                          debounce="600"
                        >
                        </b-form-textarea>
                      </b-col>
                    </b-row>
                  </b-list-group-item>
                </b-list-group>
              </b-tab>
            </b-tabs>
          </b-card>
          <b-row class="my-3">
            <b-col cols="12">
              <b-button-toolbar>
                <b-button-group class="mx-1">
                  <b-button variant="danger" @click.stop="goBack()">
                    <b-icon-chevron-left scale="1.5" />
                  </b-button>
                </b-button-group>
                <b-button-group class="mx-1">
                  <b-button
                    variant="success"
                    ref="submit"
                    :disabled="!checklistCompleted"
                    @click.stop="confirmChecklistSubmission()"
                  >
                    <b-icon-cloud-upload scale="1.5" />
                  </b-button>
                </b-button-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <template v-slot:overlay>
            <div v-show="loading || submissionSuccessful" class="text-center">
              <p v-show="!loading && submissionSuccessful">
                La entrada ha sido guardada exit&oacute;samente, redirigiendo...
              </p>
              <b-spinner variant="default"></b-spinner>
            </div>
            <div
              v-show="userHasToAgreeToStart"
              ref="dialog"
              tabindex="-1"
              role="dialog"
              aria-modal="false"
              aria-labelledby="form-confirm-label"
              class="text-center p-3"
            >
              <p id="form-confirm-label">
                <span>
                  Una vez empezada la entrada, &eacute;sta deber&aacute; ser
                  completada. Por cada hora de inactividad, recibir&aacute; una
                  notificaci&oacute;n hasta que &eacute;sta sea completada. Para
                  poder continuar, debe permitir el accesso a ubicacion.
                </span>
                <strong>¿Desea continuar?</strong>
              </p>
              <div class="d-flex justify-content-center">
                <b-button variant="danger" class="mr-3" @click.stop="goBack()">
                  Regresar
                </b-button>
                <b-button
                  variant="success"
                  @click.stop="createCheckListAndContinueToForm()"
                  >Continuar</b-button
                >
              </div>
            </div>
          </template>
        </b-overlay>
      </main>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { clone, isNil, isEmpty, groupBy } from "ramda";
import Header from "../Header";
import * as geocoding from "../store/geocoding";
import * as common from "../store/common";

// Constants
moment.locale("es");
const CHECKPOINT_INTERVAL = 10 * 1000; // seconds

const TRANSFORM_QUESTION_TO_ANSWER = (q) => {
  if (isNil(q.checked)) {
    q.checked = false;
  }

  if (isNil(q.notes)) {
    q.notes = "";
  }

  return q;
};

function TRANSFORM_FROM_TEMPLATE(template) {
  const entry = {
    answers: template.questions,
    name: template.name,
    notes: template.notes,
    revision: template.revision,
    templateId: template.id,
  };

  // transformations
  if (isNil(entry.notes)) {
    entry.notes = "";
  }

  entry.answers = entry.answers.map(TRANSFORM_QUESTION_TO_ANSWER);

  return entry;
}

const QUESTION_GROUPER = groupBy((question) => question.category);

const IS_ANSWER_FILLED = (q) =>
  (!isNil(q.notes) && !isEmpty(q.notes)) || q.checked === true;

async function TRANSFORM_FILE_TO_B64DATA(file) {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.addEventListener("error", () =>
      reject("Failed to get the base64 from file")
    );

    reader.readAsDataURL(file);
  });
}

export default {
  name: "CheckList",
  components: {
    Header,
  },
  data() {
    return {
      loading: true,
      userHasToAgreeToStart: true,
      checklistCompleted: false,
      submissionSuccessful: false,
      files: [],
      previewImages: [],
      template: {},
      checkpointTimestamp: null,
      checkpointInterval: null,
      entry: {
        notes: "",
        answers: [],
        createdOn: null,
        entryId: null,
        locality: null,
      },
      entryCreatedOn: null, // purely for rendering purposes
      entryId: null, // purely for rendering purposes
      localities: geocoding.VALID_LOCALITIES,
    };
  },
  async created() {
    const { templateId, rev } = this.$route.params;

    this.template = this.getTemplate(templateId, rev);
    if (!this.template) {
      await this.fetchAndGetTemplate(templateId, rev);
    }

    this.loading = false;

    this.loadCheckpoint();
    if (this.hasCheckpoint) {
      this.userHasToAgreeToStart = false;

      const { checklist, timestamp } = this.getCheckpoint();

      const humanTimestamp = moment(timestamp).fromNow();
      await this.$bvModal.msgBoxOk(
        `Se ha encontrado una entrada guardada localmente de ${humanTimestamp}. Complete la entrada para poder empezar otra entrada.`,
        {
          size: "sm",
          buttonSize: "sm",
          centered: true,
          footerClass: "p-2 border-top-0",
        }
      );

      await this.refreshCurrentLocation();

      this.entry = clone(checklist);

      this.entryId = this.entry.entryId;
      this.entryCreatedOn = this.entry.createdOn;
      this.checkpointTimestamp = timestamp;

      this.registerEntryWatcher();

      if (
        this.entry.templateId !== templateId ||
        this.entry.revision !== parseInt(rev)
      ) {
        await this.fetchAndGetTemplate(
          this.entry.templateId,
          this.entry.revision
        );

        const message =
          "La entrada que actualmente esta tratando de abrir no es la misma que la entrada guardada localmente. Usted ha sido redirigido a la forma para que ésta sea completada. ¿Desea continuar?";
        const confirmation = await this.$bvModal.msgBoxConfirm(message, {
          size: "sm",
          buttonSize: "sm",
          okTitle: "Continuar",
          cancelTitle: "Regresar",
          centered: true,
          footerClass: "p-2 border-top-0",
        });
        if (confirmation) {
          this.$router.replace(
            `/templates/${this.entry.templateId}/${this.entry.revision}`
          );
        } else {
          this.goBack();
        }
      }
    } else {
      this.entry = TRANSFORM_FROM_TEMPLATE(clone(this.template));
      this.userHasToAgreeToStart = true;
    }
  },
  beforeDestroy() {
    if (this.checkpointInterval !== null) {
      clearInterval(this.checkpointInterval);
    }
  },
  computed: {
    ...mapGetters("templates", ["getTemplate"]),
    ...mapGetters("checklists", ["hasCheckpoint"]),
    categorizedQuestions() {
      if (!this.entry.answers) return {};
      const groups = QUESTION_GROUPER(this.entry.answers);
      return groups;
    },
    totalQuestions() {
      return isEmpty(this.entry) || isNil(this.entry.answers)
        ? 0
        : this.entry.answers.length;
    },
    filledCount() {
      if (isEmpty(this.entry) || isNil(this.entry.answers)) {
        return 0;
      }

      let count = 0;
      for (const question of this.entry.answers) {
        if (IS_ANSWER_FILLED(question)) {
          count++;
        }
      }

      return count;
    },
    isOverlayShown() {
      return (
        this.userHasToAgreeToStart || this.loading || this.submissionSuccessful
      );
    },
  },
  methods: {
    ...mapGetters("checklists", ["getCheckpoint"]),
    ...mapActions("templates", ["fetchTemplate"]),
    ...mapActions("checklists", {
      createCheckList: "createCheckList",
      upload: "submitCheckList",
      loadCheckpoint: "loadCheckpoint",
      saveCheckpoint: "saveCheckpoint",
      clearCheckpoint: "clearCheckpoint",
      refreshCurrentLocation: "refreshCurrentLocation",
    }),
    async guessLocality() {
      try {
        const currentLocation = await common.getCurrentPosition();
        const locality = await geocoding.guessLocality({
          latitude: currentLocation.latitude,
          longitude: currentLocation.longitude,
        });
        this.entry.locality = locality
          ? locality
          : geocoding.VALID_LOCALITIES[0].locality;
      } catch (error) {
        console.error("Setting default", error);
        this.entry.locality = geocoding.VALID_LOCALITIES[0].locality;
      }
    },
    async fetchAndGetTemplate(templateId, revision) {
      await this.fetchTemplate({
        templateId,
        revision,
      });
      this.template = this.getTemplate(templateId, revision);
    },
    registerEntryWatcher() {
      this.checkpointInterval = setInterval(
        async () => this.createEntryCheckpoint(),
        CHECKPOINT_INTERVAL
      );
    },
    async createEntryCheckpoint() {
      if (isNil(this.checkpointInterval)) return;

      const lastCheckpoint = this.getCheckpoint();
      const hasLastCheckpointTimestamp =
        !isNil(lastCheckpoint) && !isNil(lastCheckpoint.timestamp);
      const isLastCheckpointTimestampTooOld =
        Date.now() - lastCheckpoint.timestamp > CHECKPOINT_INTERVAL;

      if (
        isNil(this.checkpointTimestamp) ||
        !hasLastCheckpointTimestamp ||
        isLastCheckpointTimestampTooOld
      ) {
        const timestamp = await this.saveCheckpoint(this.entry);
        this.checkpointTimestamp = timestamp;
        await this.upload({ entry: this.entry });
      }
    },
    goBack() {
      if (this.$router.query && this.$router.query.redirectTo) {
        this.router.replace(this.$router.query.redirectTo);
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    isCategoryCompleted(category) {
      const categoryQuestions = this.categorizedQuestions[category];
      if (!categoryQuestions) return false;

      const totalQuestions = categoryQuestions.length;
      let filledCount = 0;
      for (const q of categoryQuestions) {
        if (IS_ANSWER_FILLED(q)) filledCount++;
      }

      return filledCount === totalQuestions;
    },
    async createCheckListAndContinueToForm() {
      this.userHasToAgreeToStart = false;
      try {
        await this.refreshCurrentLocation();
        await this.guessLocality();
        const { entryId, createdOn } = await this.createCheckList(this.entry);
        this.entry["entryId"] = this.entryId = entryId;
        this.entry["createdOn"] = this.entryCreatedOn = createdOn;
        this.registerEntryWatcher();
      } catch (err) {
        await this.$bvModal.msgBoxOk(
          "Debes de estar conectado a la internet y que la aplicación tenga accesso a tu ubicación",
          {
            size: "sm",
            buttonSize: "sm",
            centered: true,
            footerClass: "p-2 border-top-0",
          }
        );
        this.goBack();
      }
    },
    async confirmChecklistSubmission() {
      const confirmation = await this.$bvModal.msgBoxConfirm(
        "La entrada será marcada como completada y no se aceptarán futuros cambios. ¿Desea continuar?",
        {
          size: "sm",
          buttonSize: "sm",
          okTitle: "Completar",
          cancelTitle: "Cancelar",
          centered: true,
          footerClass: "p-2 border-top-0",
        }
      );

      if (!confirmation) {
        return;
      }

      this.loading = true;

      clearInterval(this.checkpointInterval);
      this.checkpointInterval = null;

      // set the entry as completed
      this.entry.completed = true;

      try {
        await this.upload({ entry: this.entry, images: this.files });
        this.loading = false;
        this.submissionSuccessful = true;
        await this.clearCheckpoint();
        setTimeout(() => this.goBack(), 2500);
      } catch (err) {
        this.loading = false;
        this.submissionSuccessful = false;
        /* TODO: show error */
      }
    },
    onOverlayShow() {
      if ("dialog" in this.$refs && this.$refs.dialog) {
        this.$refs.dialog.focus();
      } else if ("spinner" in this.$refs && this.$refs.spinner) {
        this.$refs.spinner.focus();
      }
    },
    onOverlayHide() {
      // return the focus to the button
      this.$refs.submit.focus();
    },
  },
  watch: {
    filledCount(newValue) {
      this.checklistCompleted = newValue === this.totalQuestions;
    },
    files(newFiles) {
      Promise.all(newFiles.map((f) => TRANSFORM_FILE_TO_B64DATA(f))).then(
        (b64s) => {
          this.previewImages = b64s;
        }
      );
    },
  },
  filters: {
    timestamp(value) {
      return moment(value).format("dddd Do MMM YYYY, hh:mm:ss a");
    },
    maxLength(value) {
      return `${value.slice(0, 12)}...`;
    },
  },
};
</script>
